import { Suspense } from "react"
import { useTranslation } from "react-i18next"
import { PreviewDocumentDialogWrapper } from "@/components/preview-document-dialog"
import { DeprecatedConfirmationDialog } from "@/components/ui/deprecated-confirmation-dialog"
import { CreateEpisodeOfCareDialog } from "@/modules/patients/detail/episode-of-care/create-episode-of-care-dialog"
import { EditEpisodeOfCareDialog } from "@/modules/patients/detail/episode-of-care/edit-episode-of-care-dialog"
import { useConfirmDialogStoreContext } from "@/modules/patients/detail/store/useConfirmDialogStore"
import { useEditEpisodeOfCareDialogStoreContext } from "@/modules/patients/detail/store/useEpisodeOfCareDialogStore"
import { useEpisodeOfCareStoreContext } from "@/modules/patients/detail/store/useEpisodeOfCareStore"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"

const EpisodeOfCareActionsContainer = () => {
  const { t } = useTranslation()
  const countryCode = useCountryParam()
  const patientId = usePatientParam()

  const episodeOfCareRef = useEditEpisodeOfCareDialogStoreContext((state) => state.episodeOfCareRef)
  const setEpisodeOfCareRef = useEditEpisodeOfCareDialogStoreContext((state) => state.setEpisodeOfCareRef)

  const deleteConfirmationDialogParams = useConfirmDialogStoreContext((state) => state.deleteConfirmationDialogParams)
  const disableDeleteConfirmationDialog = useConfirmDialogStoreContext((state) => state.closeDeleteConfirmationDialog)

  const progressNoteId = useEpisodeOfCareStoreContext((state) => state.progressNoteId)

  return (
    <>
      <Suspense fallback={null}>
        {patientId && progressNoteId && <CreateEpisodeOfCareDialog country={countryCode} patientId={patientId} />}
      </Suspense>

      {episodeOfCareRef && (
        <EditEpisodeOfCareDialog country={countryCode} onDialogOpenChange={() => setEpisodeOfCareRef(null)} />
      )}

      {deleteConfirmationDialogParams && (
        <DeprecatedConfirmationDialog
          title={deleteConfirmationDialogParams.title}
          content={deleteConfirmationDialogParams?.content ?? t("episodeOfCare.deleteProgressNote.content")}
          open={true}
          onConfirm={() => deleteConfirmationDialogParams?.handleDelete()}
          onCancel={disableDeleteConfirmationDialog}
          confirmVariant="danger"
          confirmText={t("common.button.delete")}
          cancelText={t("common.button.keep")}
          onOpenChange={disableDeleteConfirmationDialog}
        />
      )}
      <PreviewDocumentDialogWrapper />
    </>
  )
}

export { EpisodeOfCareActionsContainer }
